import service from './axios';

// 获取用户管理列表
export const fetchUserManagementList = (params) => {
  return service({
    method: 'get',
    url: '/manage/users',
    params
  });
};

// 获取用户消费记录
export const fetchUserConsumptionRecords = (userId, params) => {
  return service({
    method: 'get',
    url: `/manage/users/${userId}/consumptions`,
    params
  });
};